<div class="mb-27 mct-flex mct-row mct-justify-between mct-items-center"  >
  <span class="title-header">{{ 'coupons.search.coupons' | translate | titlecase }}</span>
  <button pButton type="button"  class="mct-flex atlas-btn atlas-btn-primary mct-justify-center mct-items-center" type="button" (click)="addDialog.open()">
    <i class="large-icon pi pi-plus"></i>
    <span>{{ 'coupons.search.add-a-coupon' | translate | uppercase }}</span>
  </button>
</div>

<div class="params-container mb-20">
  <div class="search-header mb-32">{{ 'coupons.search.search-coupons' | translate | titlecase }}</div>
  <wl-coupon-search-params [(searchParams)]="searchParams"></wl-coupon-search-params>
  <div class="mt-33 mct-flex mct-row mct-justify-end mct-items-center"  >
    <button pButton type="button" class="atlas-btn atlas-btn-primary" (click)="searchGrid.search()">
      {{ 'common.run-this-search' | translate | uppercase }}
    </button>
  </div>
</div>

<wl-coupon-search-grid #searchGrid [(searchParams)]="searchParams"></wl-coupon-search-grid>

<wl-coupon-add-dialog #addDialog></wl-coupon-add-dialog>
